import React from 'react';

export type CrestShape = 'shield' | 'pointed' | 'rounded' | 'banner';

interface CrestProps {
  shape: CrestShape;
  color: string;
  className?: string;
}

/**
 * Watermark crest for the club cards in the hero.
 *
 * These were previously FontAwesome's faShieldCat, faShieldDog and
 * faShieldVirus — novelty icons standing in for football club crests, which
 * read as a joke on a card being shown to club executives. Drawing the
 * silhouettes inline also lets the four @fortawesome packages come out of the
 * dependency tree; they were pulled in for six icons on this one component.
 */
const PATHS: Record<CrestShape, string> = {
  shield: 'M50 4 92 20v34c0 24-18 38-42 46C26 92 8 78 8 54V20L50 4z',
  pointed: 'M50 4 92 18v30c0 26-20 42-42 52C28 90 8 74 8 48V18L50 4z',
  rounded: 'M50 4c24 0 42 8 42 8v36c0 26-18 42-42 52C26 90 8 74 8 48V12S26 4 50 4z',
  banner: 'M12 6h76v54c0 20-16 30-38 40C28 90 12 80 12 60V6z',
};

const Crest: React.FC<CrestProps> = ({ shape, color, className = '' }) => (
  <svg
    viewBox="0 0 100 100"
    className={className}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path d={PATHS[shape]} fill={color} />
    <path
      d={PATHS[shape]}
      stroke={color}
      strokeWidth="2"
      opacity="0.6"
      transform="translate(50 50) scale(0.78) translate(-50 -50)"
    />
  </svg>
);

export default Crest;
